import { render, staticRenderFns } from "./ConcernSubstancesSection.vue?vue&type=template&id=21142d79&scoped=true&"
import script from "./ConcernSubstancesSection.vue?vue&type=script&lang=js&"
export * from "./ConcernSubstancesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21142d79",
  null
  
)

export default component.exports